export function isDev(): boolean {
    // Only the dev server: production builds and tests (mode `test`) are not development.
    return import.meta.env.MODE === 'development';
}

export function version(): string {
    return import.meta.env.REACT_APP_VERSION || 'unknown';
}
